import React, { FC } from 'react';
import { SVGProps } from '@utils';
import { SvgWrapper } from './SvgWrapper';

export const MobileCloseButton: FC<SVGProps> = ({ onClick, divClassName }) => (
  <SvgWrapper
    divClassName={divClassName}
    onClick={onClick}
  >
    <svg width="72" height="72" viewBox="0 0 72 72" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_dd_4506_53759)">
        <g filter="url(#filter1_d_4506_53759)">
          <circle cx="36" cy="33" r="28" fill="white"/>
        </g>
        <path fillRule="evenodd" clipRule="evenodd" d="M26.6217 23.1073C26.3625 23.2269 26.1994 23.3965 26.0889 23.6611C25.9845 23.9112 25.9843 24.0813 26.0883 24.3331C26.1458 24.4729 27.4114 25.7744 30.33 28.6955L34.4896 32.8588L30.3056 37.0492C25.7972 41.5645 25.9397 41.404 26.0272 41.871C26.0989 42.2533 26.4648 42.6193 26.8469 42.691C27.3137 42.7786 27.1533 42.9211 31.6666 38.411L35.8551 34.2255L40.0437 38.411C44.557 42.9211 44.3966 42.7786 44.8634 42.691C45.2455 42.6193 45.6114 42.2533 45.683 41.871C45.7706 41.404 45.913 41.5645 41.4048 37.0493L37.221 32.8591L41.4048 28.6689C45.913 24.1538 45.7706 24.3142 45.683 23.8472C45.6114 23.465 45.2455 23.0989 44.8634 23.0272C44.3966 22.9396 44.557 22.7971 40.0435 27.3074L35.8548 31.493L31.6932 27.3317C28.7732 24.412 27.4723 23.1459 27.3326 23.0883C27.0728 22.981 26.8843 22.9861 26.6217 23.1073Z" fill="#434649"/>
      </g>
      <defs>
        <filter id="filter0_dd_4506_53759" x="0" y="0" width="72" height="72" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix"/>
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
          <feOffset/>
          <feGaussianBlur stdDeviation="0.5"/>
          <feColorMatrix type="matrix" values="0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.31 0"/>
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_4506_53759"/>
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
          <feOffset dy="3"/>
          <feGaussianBlur stdDeviation="4"/>
          <feColorMatrix type="matrix" values="0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.16 0"/>
          <feBlend mode="normal" in2="effect1_dropShadow_4506_53759" result="effect2_dropShadow_4506_53759"/>
          <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_4506_53759" result="shape"/>
        </filter>
        <filter id="filter1_d_4506_53759" x="6" y="3" width="60" height="60" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix"/>
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
          <feOffset/>
          <feGaussianBlur stdDeviation="1"/>
          <feColorMatrix type="matrix" values="0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.25 0"/>
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_4506_53759"/>
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_4506_53759" result="shape"/>
        </filter>
      </defs>
    </svg>



  </SvgWrapper>
);
